import React, { useEffect, useRef, useState } from 'react'
import { Header } from './header'
import { Footer } from './footer'
import { useNavigate, useParams } from 'react-router-dom'
import Slider from "react-slick";
import { listproduct, viewproducts } from '../services/homeser';

export const CardDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);
    const [product, setProduct] = useState([]);
    const [images, setImages] = useState([]);
    const [relatedproduct, setRelatedproduct] = useState([]);
    const [prevProduct, setPrevProduct] = useState(null);
    const [nextProduct, setNextProduct] = useState(null);
    useEffect(() => {
        setNav1(sliderRef1);
        setNav2(sliderRef2);
    }, []);
    const mainSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true, // Smooth transition between main images
    };

    const thumbSettings = {
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        focusOnSelect: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    };
    // const images = [
    //     require("../assets/images/product/01.jpg"),
    //     require("../assets/images/product/01.jpg"),
    //     require("../assets/images/product/01.jpg"),
    //     require("../assets/images/product/01.jpg"),
    //     require("../assets/images/product/01.jpg")
    // ];

    useEffect(() => {
        viewproducts(id).then((res) => {
            if (res.status) {
                setProduct(res.data);
                setImages(res.data.product_images);
                const temp = new FormData();
                temp.append("product_category_id", res.data.product_category_id);
                listproduct(temp).then((resp) => {
                    if (resp.status) {
                        const allProducts = [...resp.data].sort((a, b) => a.id - b.id);

                        const currentIndex = allProducts.findIndex(
                            (item) => item.id === res.data.id
                        );

                        // Set related products (excluding current)
                        const filtered = allProducts.filter(
                            (item) => item.id != res.data.id
                        );
                        setRelatedproduct(filtered);

                        // Set prev product
                        if (currentIndex > 0) {
                            setPrevProduct(allProducts[currentIndex - 1]);
                        } else {
                            setPrevProduct(null);
                        }

                        // Set next product
                        if (currentIndex < allProducts.length - 1) {
                            setNextProduct(allProducts[currentIndex + 1]);
                        } else {
                            setNextProduct(null);
                        }
                    }
                })
            }
        })
    }, [id]);
    return (
        <>
            <Header />
            <section className="inner-section single-banner" style={{ background: "url(" + require("../assets/images/slider/single-banner.jpg") + ") no-repeat center" }}>
                <div className="container">
                    <h2>{product?.product_name}</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href='index.html'>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">{product?.product_name}</li>
                    </ol>
                </div>
            </section>

            <section className="inner-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="details-gallery">
                                <div className="details-label-group">
                                    <label className="details-label new">{product?.product_category?.category_name}</label>
                                    {/* <label className="details-label off">-10%</label> */}
                                </div>
                                <Slider
                                    {...mainSettings}
                                    asNavFor={nav2}
                                    ref={slider => (sliderRef1 = slider)}
                                    className="details-preview"
                                >
                                    {images.map((img, index) => (
                                        <div key={index}>
                                            <img src={img} alt="product" style={{ width: '100%' }} />
                                        </div>
                                    ))}
                                </Slider>

                                {/* Thumbnail Slider */}
                                <Slider
                                    {...thumbSettings}
                                    asNavFor={nav1}
                                    ref={slider => (sliderRef2 = slider)}
                                    className="details-thumb"
                                >
                                    {images.map((img, index) => (
                                        <div key={index} className="thumb-item">
                                            <img src={img} alt="thumbnail" />
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <ul className="product-navigation">
                                <li className="product-nav-prev">
                                    {prevProduct && (
                                        <a onClick={() => navigate('/carddetails/' + prevProduct.id)}>
                                            <i className="icofont-arrow-left"></i>
                                            prev product
                                            <span className="product-nav-popup">
                                                <img src={prevProduct?.product_images[0]} alt="product" />
                                                <small>{prevProduct?.product_name}</small>
                                            </span>
                                        </a>
                                    )}
                                </li>
                                <li className="product-nav-next">
                                    {nextProduct && (
                                        <a onClick={() => navigate('/carddetails/' + nextProduct.id)}>
                                            next product
                                            <i className="icofont-arrow-right"></i>
                                            <span className="product-nav-popup">
                                                <img src={nextProduct.product_images[0]} alt="product" />
                                                <small>{nextProduct.product_name}</small>
                                            </span>
                                        </a>
                                    )}
                                </li>
                            </ul>
                            <div className="details-content">
                                <h3 className="details-name"><a >{product?.product_name}</a></h3>

                                <h3 className="details-price">
                                    {product?.offer_price != 0 ? (
                                        <><del>₹{product?.mrp_price}</del>
                                            <span>₹{product?.offer_price}<small>/piece</small></span></>
                                    ) : (
                                        <span>₹{product?.mrp_price}<small>/piece</small></span>
                                    )

                                    }

                                </h3>
                                <p className="details-desc">{product?.product_description}</p>


                                <div className="details-action-group">
                                    <a className="details-wish wish" title="Add Your Wishlist" href="tel:+9865230900">
                                        <i className="fas fa-phone-alt"></i>
                                        <span>Call Now</span>
                                    </a>
                                    <a className='details-compare' title='Compare This Item' onClick={() => {
                                        const phone = "919865230900";
                                        const message = encodeURIComponent(
                                            `Hi, I’d like to know more about this product: ${product.product_name}`
                                        );

                                        window.open(
                                            `https://wa.me/${phone}?text=${message}`,
                                            "_blank"
                                        );
                                    }}>
                                        <i className="fab fa-whatsapp"></i>
                                        <span>WhatsApp</span>
                                    </a>
                                </div>
                                <p className="note-text">
                                    * Note: All designs and prices may vary based on quantity.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {relatedproduct?.length > 0 &&
                <section className="inner-section">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="section-heading">
                                    <h2>related this items</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
                            {relatedproduct?.map((item, index) => (
                                <div className="col" key={index}>
                                    <div className="product-card">
                                        <div className="product-media">
                                            <div className="product-label">
                                                <label className="label-text new">{item?.product_category?.category_name}</label>
                                            </div>
                                            <button className="product-wish wish active" onClick={() => {
                                                const phone = "919865230900";
                                                const message = encodeURIComponent(
                                                    `Hi, I’d like to know more about this product: ${item.product_name}`
                                                );

                                                window.open(
                                                    `https://wa.me/${phone}?text=${message}`,
                                                    "_blank"
                                                );
                                            }}>
                                                <i className="fas fa-whatsapp"></i>
                                            </button>
                                            <a className='product-image' onClick={() => navigate('/carddetails/' + item?.id)}>
                                                <img src={item?.product_images[0]} alt="product" />
                                            </a>
                                        </div>
                                        <div className="product-content">
                                            <h6 className="product-name">
                                                <a onClick={() => navigate('/carddetails/' + item?.id)}>{item?.product_name}</a>
                                            </h6>
                                            <h6 className="product-price">
                                                <del>₹{item?.mrp_price}</del>
                                                <span>₹{item?.offer_price}<small>/piece</small></span>
                                            </h6>
                                            <button className="product-add" title="Add to Cart">
                                                <a href='https://wa.me/919000000000'></a>
                                                <span>View All</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))

                            }



                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-btn-25">
                                    <a className='btn btn-outline' onClick={() => navigate('/cards')}>
                                        <i className="fas fa-eye"></i>
                                        <span>view all related</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            }



            <Footer />
        </>
    )
}
